import { CheckboxItem } from '@/components/CheckboxItem';
import type { FilterItem } from '@/features/fanfiction-filters/types/fanfiction-filters.types';
import { getFilterItemId } from '../../CharacterFilterList.utils';
import {
  createCharacterToggleHandler,
  createPermalinkNavigateHandler,
} from './CharacterFilterItem.utils';

interface CharacterFilterItemProps {
  item: FilterItem;
  selectedCharacters: string[];
  selectedFandoms: string[];
  characterIdToName: Record<string, string>;
  characters: FilterItem[];
  onCharactersChange?: (characters: string[], selectedLabels?: Record<string, string>) => void;
  onSingleCharacterNavigate?: (characterId: string, fandomId: string) => void;
  onCharacterLabelCached?: (characterId: string, characterName: string) => void;
}

export const CharacterFilterItem = ({
  item,
  selectedCharacters,
  selectedFandoms,
  characterIdToName,
  characters,
  onCharactersChange,
  onSingleCharacterNavigate,
  onCharacterLabelCached,
}: CharacterFilterItemProps) => {
  const itemId = getFilterItemId(item);
  const handleToggle = createCharacterToggleHandler({
    item,
    itemId,
    selectedCharacters,
    selectedFandoms,
    characterIdToName,
    characters,
    onCharactersChange,
    onSingleCharacterNavigate,
    onCharacterLabelCached,
  });

  return (
    <CheckboxItem
      item={{ ...item, checked: selectedCharacters.includes(itemId) }}
      onClick={handleToggle}
      onPermalinkNavigate={createPermalinkNavigateHandler(handleToggle)}
    />
  );
};
